import { Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
import style from "../../Styles/vehicleInfo.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";
import { replaceMacro } from "../../Utils/utils";
import GenericTemplate from "../Templates/GenericTemplate";

export function VehicleDescriptionSection({
  control,
  formState,
  editButton,
  descriptionTemplates,
  selectedTemplate,
  setSelectedTemplate,
  setValue,
  vehicle,
  cache,
}) {
  return (
    <fieldset
      style={{
        marginTop: 50,
        borderRadius: 10,
        margin: 10,
        borderColor: "#d6d6d6",
        borderStyle: "solid",
        color: "#444",
      }}
    >
      <legend>{Vocabulary.description}</legend>

      <Autocomplete
        freeSolo={false}
        disablePortal
        options={descriptionTemplates}
        disabled={editButton}
        isOptionEqualToValue={(option, value) => option?.templateName === value?.templateName}
        value={selectedTemplate}
        onChange={(event, value) => {
          if (value) {
            setValue("descriere", replaceMacro(value.html, vehicle, cache));
            setSelectedTemplate(value);
          } else {
            setValue("descriere", vehicle?.descriere);
            setSelectedTemplate(null);
          }
        }}
        getOptionLabel={(option) => option?.templateName}
        renderInput={(params) => (
          <TextField
            {...params}
            className={style.textField}
            id="descriptionTemplate"
            name="descriptionTemplate"
            label={Vocabulary.templateName}
          />
        )}
        style={{ marginBottom: 30 }}
      />

      <Controller
        name="descriere"
        control={control}
        defaultValue={formState.defaultValues?.descriere}
        render={({ field: { value, onChange } }) => (
          <GenericTemplate
            template={{ html: value ? value : "" }}
            fromVehicle={true}
            handleChangeGenericTemplate={(value) => {
              onChange(value);
              setSelectedTemplate(null);
            }}
          />
        )}
      />
    </fieldset>
  );
}

export default VehicleDescriptionSection;
